import React, { useState, useEffect } from "react";
import Select from "react-select";
import { toast } from "react-toastify";
import API_BASE_URL from "../../API/ConfigAPI";
import { Dropdown } from "react-bootstrap";
import BarreNavigation from "../../components/BarreNavigation/BarreNavigation";
import Navbarhorizontal from "../../components/Navbarhorizontal/Navbarhorizontal";
import Modal from "../../components/Modal/Modal";
import FacturationTable from "../../components/FacturationTable/FacturationTable";
import useFacturation from "../../hooks/useFacturation";
import { monthToDate } from "../../utils/dateUtils";
import {
  computeStatusCounts,
  getGestionnaireOptions,
} from "../../utils/facturationUtils";
import {
  generateFacture,
  exportFacture,
  sendFactureEmail,
  fetchWithToken,
} from "../../utils/apiHelpers";
import MonthSelector from "../../components/MonthSelector/MonthSelector";
import StatutBadges from "../../components/StatutBadges/StatutBadges";
import SpinnerLoader from "../../components/SpinnerLoader/SpinnerLoader";
import "./gestionfacturation.css";

function GestionFacturation() {
  const {
    facturations,
    setFacturations,
    selectedMonth,
    setSelectedMonth,
    activeTabs,
    isLoading,
  } = useFacturation({ excludeAFaire: true });

  const [selectedGestionnaires, setSelectedGestionnaires] = useState([]);
  const [availableGestionnaires, setAvailableGestionnaires] = useState([]);
  const [searchRaisonSociale, setSearchRaisonSociale] = useState("");
  const [selectedStatut, setSelectedStatut] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [currentFacturation, setCurrentFacturation] = useState({
    siret: "",
    mois_facturation: "",
  });
  const [modalMessage, setModalMessage] = useState("");

  const [confirmationModal, setConfirmationModal] = useState({
    isOpen: false,
    message: "",
    onConfirm: null,
  });

  const openConfirmationModal = (message, onConfirm) => {
    setConfirmationModal({
      isOpen: true,
      message,
      onConfirm,
    });
  };
  const [exportModal, setExportModal] = useState({
    isOpen: false,
    exportType: "",
    moisInput: "",
  });

  const closeConfirmationModal = () => {
    setConfirmationModal({
      isOpen: false,
      message: "",
      onConfirm: null,
    });
  };

  const [showDownloadConfirmModal, setShowDownloadConfirmModal] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);


  const filterBySelectedMonth = (facturation) => {
    const facturationDate = monthToDate(facturation.mois_facturation);
    const selectedDate = monthToDate(selectedMonth);
    return (
      facturationDate.getMonth() === selectedDate.getMonth() &&
      facturationDate.getFullYear() === selectedDate.getFullYear()
    );
  };
  useEffect(() => {
    if (activeTabs.length > 0) {
      const sortedTabs = [...activeTabs].sort(
        (a, b) => monthToDate(b) - monthToDate(a)
      );
      setSelectedMonth(sortedTabs[0]);
    }
  }, [activeTabs, setSelectedMonth]);

  //  fonctions

  const handleStatusChange = (id, event) => {
    const newStatus = event.target.value;
    if (newStatus === "Terminé") {
      openConfirmationModal(
        "Confirmez-vous le changement de statut en 'Terminé' ?",
        () => changeStatus(id, newStatus)
      );
    } else {
      changeStatus(id, newStatus);
    }
  };

  const changeStatus = async (id, newStatus) => {
    const facturationToUpdate = facturations.find((f) => f.id === id);
    if (!facturationToUpdate) return toast.error("Facturation non trouvée");

    const updatedFacturation = { ...facturationToUpdate, statut: newStatus };

    try {
      await fetchWithToken(`${API_BASE_URL}/home/api/facturations/${id}/`, {
        method: "PUT",
        body: JSON.stringify(updatedFacturation),
      });

      setFacturations((prev) =>
        prev.map((f) => (f.id === id ? updatedFacturation : f))
      );
      toast.success("Statut mis à jour avec succès !");
    } catch (error) {
      console.error(error);
      toast.error("Erreur lors de la mise à jour du statut");
    }
  };

  const handleGeneratePDF = async (siret, mois, statut) => {
    try {
      const res = await fetchWithToken(
        `${API_BASE_URL}/home/api/generate-facture/`,
        {
          method: "POST",
          body: JSON.stringify({
            siret: siret,
            mois_facturation: mois,
          }),
        },
        false // on récupère un blob (PDF), pas du JSON
      );
  
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `facture_${siret}_${mois}.pdf`;
  
      openConfirmationModal("Voulez-vous télécharger la facture PDF ?", () => {
        a.click();
        toast.success(`Téléchargement de la facture ${siret} (${mois}) lancé ✅`, {
          className: "myToastClassNamesuccés",
          progressClassName: "myToastProgressClassName",
        });
      });
      
    } catch (error) {
      console.error("Erreur lors du téléchargement du PDF :", error);
      toast.error("Erreur lors de la génération de la facture PDF.");
    }
  };
  

  const handleSendEmail = (siret, mois) => {
    const facturation = facturations.find(
      (f) => f.siret === siret && f.mois_facturation === mois
    );

    if (facturation?.date_envoi_mail) {
      const formatted = new Date(
        facturation.date_envoi_mail
      ).toLocaleDateString("fr-FR");
      setCurrentFacturation({ ...facturation });
      setModalMessage(
        `Un email a déjà été envoyé le ${formatted}. Souhaitez-vous effectuer une relance ou renvoyer sans mention ?`
      );
      setShowConfirmModal(true);
    } else {
      sendFactureEmail({ siret, mois }, (data) => {
        setFacturations((prev) =>
          prev.map((f) =>
            f.siret === siret && f.mois_facturation === mois
              ? { ...f, emailSent: true, date_envoi_mail: data.date_envoi_mail }
              : f
          )
        );
      });
    }
  };

  const performSendEmail = async (siret, mois, relance = false) => {
    try {
      const body = {
        siret: siret,
        mois_facturation: mois,
        ...(relance ? { relance: true } : { envoyer: true }),
      };

      const data = await fetchWithToken(
        `${API_BASE_URL}/home/api/envoyer_facture/`,
        {
          method: "POST",
          body: JSON.stringify(body),
        },
        true
      );

      toast.success(
        (relance ? "Relance envoyée" : "Email envoyé") +
          " avec succès le " +
          new Date(data.date_envoi_mail).toLocaleDateString("fr-FR")
      );

      setFacturations((prev) =>
        prev.map((facture) =>
          facture.siret === siret && facture.mois_facturation === mois
            ? {
                ...facture,
                date_envoi_mail: data.date_envoi_mail,
                emailSent: true,
                nb_envoi_facture: data.nb_envoi_facture,
              }
            : facture
        )
      );
      if (relance) {
        toast.info(`Relance x${(Number(data.nb_envoi_facture) || 0) - 1} enregistrée ✅`, {
          autoClose: 3000,
          className: "myToastClassNameinfo",
          progressClassName: "myToastProgressClassName",
        });
      }
    } catch (err) {
      console.error("Erreur Email:", err);
      toast.error("Erreur lors de l'envoi de l'email.");
    }
  };

  
  const handleMarkAllAsTerminatedClick = () => {
    openConfirmationModal(
      `Êtes-vous sûr de vouloir terminer toutes les factures 'En revue' pour le mois ${selectedMonth} ?`,
      async () => {
        const enRevue = facturations.filter(
          (f) => f.statut === "En revue" && filterBySelectedMonth(f)
        );

        try {
          await Promise.all(
            enRevue.map((f) =>
              fetchWithToken(`${API_BASE_URL}/home/api/facturations/${f.id}/`, {
                method: "PUT",
                body: JSON.stringify({ ...f, statut: "Terminé" }),
              })
            )
          );

          setFacturations((prev) =>
            prev.map((f) =>
              f.statut === "En revue" && filterBySelectedMonth(f)
                ? { ...f, statut: "Terminé" }
                : f
            )
          );

          toast.success(
            "Toutes les factures 'En revue' sont maintenant 'Terminées'"
          );
        } catch (error) {
          console.error(error);
          toast.error("Erreur lors de la mise à jour des statuts");
        }
      }
    );
  };

  const handleExport = (type) => {
    setExportModal({
      isOpen: true,
      exportType: type,
      moisInput: "",
    });
  };

  useEffect(() => {
    setAvailableGestionnaires(getGestionnaireOptions(facturations));
  }, [facturations]);

  const handleSelectChange = (selectedOptions) => {
    setSelectedGestionnaires(selectedOptions);
  };

  const statusCounts = computeStatusCounts(facturations, filterBySelectedMonth);

 const [isSendingAllEmails, setIsSendingAllEmails] = useState(false);
  const [showSendAllEmailsModal, setShowSendAllEmailsModal] = useState(false);


 const handleSendAllEmails = () => {
  const facturesAEnvoyer = facturations.filter(
    (f) =>
      f.statut === "Terminé" && filterBySelectedMonth(f) && !f.date_envoi_mail
  );

  if (facturesAEnvoyer.length === 0) {
    toast.info("Aucune facture à envoyer.");
    return;
  }
  setShowSendAllEmailsModal(true);
  };

//   openConfirmationModal(
//     `La facturation de ${facturesAEnvoyer.length} société(s) est terminée. Voulez-vous envoyer les factures ?`,
//     async () => {
//        setIsSendingEmails(true);
//       try {
//         for (const facture of facturesAEnvoyer) {
//           await sendFactureEmail(
//             { siret: facture.siret, mois: facture.mois_facturation },
//             (data) => {
//               setFacturations((prev) =>
//                 prev.map((f) =>
//                   f.siret === facture.siret &&
//                   f.mois_facturation === facture.mois_facturation
//                     ? {
//                         ...f,
//                         date_envoi_mail: data.date_envoi_mail,
//                         emailSent: true,
//                       }
//                     : f
//                 )
//               );
//             },
//             null,
//             false // ❌ pas de toast individuel
//           );
//         }

//         toast.success("Tous les emails ont été envoyés avec succès !");
//       } catch (err) {
//         console.error(err);
//         toast.error("Erreur lors de l'envoi en masse des emails.");
//       }finally {
//         setIsSendingEmails(false);
//       }
//     }
//   );
// };
const executeSendAllEmails = async () => {
  const facturesAEnvoyer = facturations.filter(
    (f) =>
      f.statut === "Terminé" && filterBySelectedMonth(f) && !f.date_envoi_mail
  );

  setIsSendingAllEmails(true);
  try {
    for (const facture of facturesAEnvoyer) {
      await sendFactureEmail(
        { siret: facture.siret, mois: facture.mois_facturation },
        (data) => {
          setFacturations((prev) =>
            prev.map((f) =>
              f.siret === facture.siret &&
              f.mois_facturation === facture.mois_facturation
                ? {
                    ...f,
                    date_envoi_mail: data.date_envoi_mail,
                    emailSent: true,
                  }
                : f
            )
          );
        },
        null,
        false
      );
    }
    toast.success("Tous les emails ont été envoyés avec succès !");
  } catch (err) {
    console.error(err);
    toast.error("Erreur lors de l'envoi en masse des emails.");
  } finally {
    setIsSendingAllEmails(false);
    setShowSendAllEmailsModal(false);
  }
};



  const displayTitleMonth = () => {
    const [month, year] = selectedMonth.split("-");
    const monthFormatted = month.charAt(0).toUpperCase() + month.slice(1);
    return `${monthFormatted} ${year}`;
  };

  const handleDownloadAllFactures = async () => {
  const moisFacturation = selectedMonth; // exemple: avril-2024
  const token = localStorage.getItem("token");

  try {
     setIsDownloading(true);  // <-- active le loading
    const response = await fetch(`${API_BASE_URL}/home/api/factures/zip/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
      body: JSON.stringify({ mois_facturation: moisFacturation }),
    });

    if (!response.ok) {
      throw new Error("Erreur lors du téléchargement des factures ZIP.");
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `factures_${moisFacturation}.zip`;
    document.body.appendChild(a);
    a.click();
    a.remove();

    toast.success(`Le fichier ZIP des factures (${moisFacturation}) a été téléchargé avec succès.`);
  } catch (err) {
    console.error(err);
    toast.error("Erreur lors du téléchargement du fichier ZIP des factures.");
  }finally {
    setIsDownloading(false);  // <-- désactive le loading
  }
};


  return (
    <div className="parent-layout">
      <BarreNavigation />
      <div className="content">
        <div>
          <Navbarhorizontal />
        </div>
        <Modal
          isOpen={confirmationModal.isOpen}
          title="Confirmation"
          onClose={closeConfirmationModal}
        >
          <p>{confirmationModal.message}</p>
          <div className="form-actions">
            <button className="cancel-button" onClick={closeConfirmationModal}>
              Annuler
            </button>
            <button
              className="submit-button"
              onClick={() => {
                confirmationModal.onConfirm();
                closeConfirmationModal();
              }}
            >
              Confirmer
            </button>
          </div>
        </Modal>
        <Modal
          isOpen={exportModal.isOpen}
          title="Exporter la facturation"
          onClose={() =>
            setExportModal({ isOpen: false, exportType: "", moisInput: "" })
          }
        >
          <div
          className="export-modal"
          >
            <p>
              Veuillez saisir le mois au format <strong>mois-année</strong> (ex:
              mars-2024) :
            </p>
            <input
              type="text"
              value={exportModal.moisInput}
              onChange={(e) =>
                setExportModal((prev) => ({
                  ...prev,
                  moisInput: e.target.value,
                }))
              }
              placeholder="mars-2024"
             className="export-modal-date "
            />
            <div className="form-actions">
              <button
                className="cancel-button"
                onClick={() =>
                  setExportModal({
                    isOpen: false,
                    exportType: "",
                    moisInput: "",
                  })
                }
              >
                Annuler
              </button>
              <button
                className="submit-button"
                onClick={() => {
                  const mois = exportModal.moisInput.trim().toLowerCase();
                  const isValid =
                    /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)-\d{4}$/.test(
                      mois
                    );
                  if (!isValid) {
                    toast.error(
                      "Format invalide. Utilisez mois-année, ex: mars-2024."
                    );
                    return;
                  }
                  exportFacture(mois, exportModal.exportType);
                  setExportModal({
                    isOpen: false,
                    exportType: "",
                    moisInput: "",
                  });
                }}
              >
                Exporter
              </button>
            </div>
          </div>
        </Modal>

        <Modal
          isOpen={showConfirmModal}
          onClose={() => setShowConfirmModal(false)}
          title="Confirmation d'envoi"
        >
          <div className="modal-body">
            <p>{modalMessage}</p>
            <div className="container_btn">
              <button
                className="cancel-button btn-modal-gesf"
                onClick={() => setShowConfirmModal(false)}
              >
                Annuler
              </button>
              <button
                className="submit-button btn-modal-gesf"
                onClick={() => {
                  performSendEmail(
                    currentFacturation.siret,
                    currentFacturation.mois_facturation,
                    false
                  );
                  setShowConfirmModal(false);
                }}
              >
                Renvoyer
              </button>
              <button
                className="submit-button btn-modal-gesf"
                onClick={() => {
                  performSendEmail(
                    currentFacturation.siret,
                    currentFacturation.mois_facturation,
                    true
                  );
                  setShowConfirmModal(false);
                }}
              >
                Relancer
              </button>
            </div>
          </div>
        </Modal>

        <Modal
  isOpen={showDownloadConfirmModal}
  title="Confirmation de téléchargement"
  onClose={() => {
    if (!isDownloading) {
      setShowDownloadConfirmModal(false);
    }
  }}
>
  <div className="modal-body">
    <p>
      Voulez-vous vraiment télécharger toutes les factures ZIP pour le mois{" "}
      <strong>{selectedMonth}</strong> ?
    </p>

    {isDownloading ? (
      <div style={{ textAlign: "center", marginTop: "1rem" }}>
        <span className="spinner" /> Téléchargement en cours...
      </div>
    ) : (
      <div className="form-actions">
        <button
          className="cancel-button"
          onClick={() => setShowDownloadConfirmModal(false)}
        >
          Annuler
        </button>
        <button
          className="submit-button"
          onClick={async () => {
            setIsDownloading(true);
            await handleDownloadAllFactures();
            setIsDownloading(false);
            setShowDownloadConfirmModal(false);
          }}
        >
          Télécharger
        </button>
      </div>
    )}
  </div>
</Modal>

<Modal
  isOpen={showSendAllEmailsModal}
  title="Confirmation d'envoi de masse"
  onClose={() => setShowSendAllEmailsModal(false)}
>
  <div className="modal-body">
    {isSendingAllEmails ? (
      <div style={{ textAlign: "center", marginTop: "1rem" }}>
        <span className="spinner" /> Envoi en cours...
      </div>
    ) : (
      <>
        <p>
          La facturation de {facturations.filter(
            (f) => f.statut === "Terminé" && filterBySelectedMonth(f) && !f.date_envoi_mail
          ).length} société(s) est terminée. Voulez-vous envoyer les factures ?
        </p>
        <div className="form-actions">
          <button
            className="cancel-button"
            onClick={() => setShowSendAllEmailsModal(false)}
          >
            Annuler
          </button>
          <button
            className="submit-button"
            onClick={executeSendAllEmails}
          >
            Confirmer
          </button>
        </div>
      </>
    )}
  </div>
</Modal>




        <div className="container">
          <h1>Facturation de {displayTitleMonth()}</h1>
          {/* <div className="sous-titre">
            <h2 className="mb-3">Facturation du mois  {selectedMonth}</h2>
          </div> */}
          <div className="banner">
            <div className="search-filtre-container">
              <input
                type="text"
                placeholder="Recherche"
                value={searchRaisonSociale}
                onChange={(e) => setSearchRaisonSociale(e.target.value)}
                className="search-input-gestionfac"
              />

              <Select
                className="filtres-gestionnaires"
                options={availableGestionnaires}
                isMulti
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                onChange={handleSelectChange}
                allowSelectAll={true}
                value={selectedGestionnaires}
                placeholder="Filtre"
              />
            </div>

            <div className="btn-container">
            <button
  className="btn-generer"
  onClick={() =>
    openConfirmationModal(
      "Êtes-vous sûr de vouloir générer toute la facturation ?",
      async () => {
        await generateFacture();
      }
    )
  }
>
  Générer la facturation
</button>
              <Dropdown>
                <Dropdown.Toggle className="btn-exporter" id="dropdown-basic">
                  Clôturer
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item
                    onClick={() => handleMarkAllAsTerminatedClick()}
                  >
                    Terminer les factures "En revue"
                  </Dropdown.Item>
                 <Dropdown.Item onClick={handleSendAllEmails}>
  Tout envoyer
</Dropdown.Item>

                   <Dropdown.Item onClick={() => setShowDownloadConfirmModal(true)}>
  Télécharger toutes les factures (ZIP)
</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              <Dropdown>
                <Dropdown.Toggle className="btn-exporter" id="dropdown-basic">
                  Exporter
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => handleExport("Oui")}>
                    Export koala complet
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => handleExport("Non")}>
                    Export koala partiel
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>

          <div className="select_month_status">
            <MonthSelector
              activeTabs={activeTabs}
              selectedMonth={selectedMonth}
              setSelectedMonth={setSelectedMonth}
              toast={toast}
            />

            <StatutBadges
              statusCounts={statusCounts}
              selectedStatut={selectedStatut}
              setSelectedStatut={setSelectedStatut}
            />
          </div>
          <div className="table-container">
            {isLoading ? (
              <SpinnerLoader />
            ) : (
              <FacturationTable
                facturations={facturations}
                selectedGestionnaires={selectedGestionnaires}
                searchRaisonSociale={searchRaisonSociale}
                selectedStatut={selectedStatut}
                filterBySelectedMonth={filterBySelectedMonth}
                handleStatusChange={handleStatusChange}
                handleGeneratePDF={handleGeneratePDF}
                sendFactureEmail={handleSendEmail}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default GestionFacturation;
